import {useCallback, useEffect, useRef, useState} from "react";
import {DialogShell} from "./DialogShell";
import {useTranslation} from "../../../shared/i18n";


export const CredentialRotationDialog = ({open, deployer, pending, error, onCancel, onConfirm}) => {
    const {t} = useTranslation();
    const [password, setPassword] = useState("");
    const [confirmation, setConfirmation] = useState("");
    const [localError, setLocalError] = useState("");
    const passwordRef = useRef(null);
    const confirmationRef = useRef(null);

    const clearSecrets = useCallback(() => {
        if (passwordRef.current) passwordRef.current.value = "";
        if (confirmationRef.current) confirmationRef.current.value = "";
        setPassword("");
        setConfirmation("");
        setLocalError("");
    }, []);

    const cancel = () => {
        clearSecrets();
        onCancel();
    };

    useEffect(() => {
        if (!open) {
            clearSecrets();
        }
    }, [clearSecrets, open]);

    const submit = (event) => {
        event.preventDefault();
        const credential = password.trim();
        if (!credential) {
            setLocalError(t("sections.deployers.p46"));
            return;
        }
        if (credential !== confirmation.trim()) {
            setLocalError(t("sections.deployers.p47"));
            return;
        }
        clearSecrets();
        onConfirm(credential);
    };

    return (
        <DialogShell open={open} title={t("sections.deployers.p19")} entity={deployer?.name || deployer?.username} pending={pending} onClose={cancel}>
            <form className="deployer-form" onSubmit={submit}>
                <div className="deployer-form-grid">
                    <label>
                        <span>{t("sections.deployers.p48")}</span>
                        <input ref={passwordRef} type="password" autoComplete="new-password" required disabled={pending} value={password} onChange={(event) => setPassword(event.target.value)} />
                    </label>
                    <label>
                        <span>{t("sections.deployers.p49")}</span>
                        <input ref={confirmationRef} type="password" autoComplete="new-password" required disabled={pending} value={confirmation} onChange={(event) => setConfirmation(event.target.value)} />
                    </label>
                </div>
                {(localError || error?.message) ? <div className="deployer-dialog-error" role="alert">{localError || error.message}</div> : null}
                <footer className="deployer-dialog-footer">
                    <button type="button" className="admin-button admin-button-secondary" disabled={pending} onClick={cancel}>{t("sections.deployers.p50")}</button>
                    <button type="submit" className="admin-button admin-button-primary" disabled={pending}>{pending ? t("sections.deployers.p51") : t("sections.deployers.p19")}</button>
                </footer>
            </form>
        </DialogShell>
    );
};
